import styled from "styled-components";
import {Typography} from "antd";

const {Text} = Typography;

export const SubCompaniesModalGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: min(55vh, calc(100vh - 220px));
    overflow-y: auto;
    padding-right: 4px;
`;

export const SubCompaniesModalCell = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 10px;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    background: #fafafa;
    min-height: 0;
`;

export const SubCompaniesModalIndex = styled(Text).attrs({strong: true})`
    && {
        color: #faad14;
        flex-shrink: 0;
    }
`;

export const SubCompaniesModalName = styled(Text)`
    && {
        flex: 1;
        min-width: 0;
        word-break: break-word;
    }
`;

export const subCompaniesModalBodyStyle = {
    maxHeight: "calc(100vh - 160px)",
    overflow: "hidden",
    padding: "16px 24px"
};
